var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.viewComponent,_vm._g({tag:"component",attrs:{"item":_vm.item,"auth-user-id":_vm.authUserId}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }